module.exports = __webpack_public_path__ + "img/walk-for-good.a2704ac9.png";